import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import AssetsIcon from "../../../Common/Svgs/AssetsIcon";
import getThemeColor, {
  getThemePrimary50Color,
} from "../../../Utils/getThemeColor";
import usePermission from "../../hooks/usePermission";
import { PERMISSIONS } from "../../../Modules/Login/constants";
import { SUBMENU } from "../data/contants";

const AssetsItem = ({ sidebarActive, subMenu, pageName }) => {
  const navigate = useNavigate();

  const { theme } = useSelector((state) => state.loggedInUser);

  const [hover, setHover] = useState(false);

  const hasTrikeModulePermission = usePermission([
    PERMISSIONS.TRIKE_VIEW,
    PERMISSIONS.TRIKE_VIEW_AND_EDIT,
  ]);

  const hasPAModulePermission = usePermission([
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW,
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW_AND_EDIT,
  ]);

  const handleNavigation = () => {
    if (hasTrikeModulePermission) {
      navigate("/assets?tab=vehicles");
      return;
    }

    if (hasPAModulePermission) {
      navigate("/assets?tab=agri-tech");
    }
  };

  const getHeaderMenuStyle = () => {
    if (pageName.toLowerCase() === "assets") {
      return "text-sidebar-active stroke-sidebar-active";
    }
    return "text-sidebar-base stroke-sidebar-base";
  };

  const getHeaderIconStyle = () => {
    // if the current page is assets, fill the header icon
    if (pageName.toLowerCase() === "assets") {
      return theme === "green-theme" ? "#fad152" : "#fff";
    }

    // if the sidebar is closed then fill color will be the theme color
    if (!sidebarActive) {
      return getThemeColor(theme);
    }

    // if none of the conditions are true then return the bgColor of the Header item (transparent-white)
    return getThemePrimary50Color(theme);
  };

  return (
    <div
      role="button"
      className={`flex items-center gap-x-2 mt-4 py-2 px-6 h-9 cursor-pointer group mx-auto
        ${
          hover && !sidebarActive ? "w-[116px] bg-primary rounded-md" : "w-full"
        }
        `}
      onClick={handleNavigation}
      onMouseEnter={() => {
        if (subMenu === SUBMENU.DEFAULT) {
          setHover(true);
        }
      }}
      onMouseLeave={() => setHover(false)}
    >
      <motion.div className="w-5 h-5">
        <AssetsIcon
          className={`group-hover:text-sidebar-active shrink-0 ${getHeaderMenuStyle()}`}
          fillColor={getHeaderIconStyle()}
        />
      </motion.div>

      {(sidebarActive || hover) && (
        <motion.p
          // layout
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className={` font-aileron font-semibold text-xs group-hover:text-sidebar-active pt-1 ${
            pageName.toLowerCase() === "assets"
              ? "text-sidebar-active"
              : "text-sidebar-base"
          }
      `}
        >
          Assets
        </motion.p>
      )}
    </div>
  );
};

export default AssetsItem;
